// Tiny same-tab handoff for the Admin/Public View switch's scroll position.
// The switch is triggered from Header.js's own mode-switch link (a plain
// history.replace toggling ?admin=1), which changes Tournament.js's
// is_authorized PROP directly and synchronously - unlike a tab switch
// (which Tournament.js buffers through its own activeTab state, letting it
// capture scrollY against the still-on-screen OLD tab before ever touching
// the new one), there's no such buffering here: by the time any effect
// inside Tournament.js can run, React has already committed the new
// is_authorized layout, and the OLD content (whatever scrollY was measured
// against) is already gone from the DOM. Capturing scrollY has to happen
// synchronously in the click handler itself, while the old content is still
// on screen - Header.js is the one place that's true, so it writes here and
// Tournament.js's own layout effect (keyed on is_authorized) reads it back
// before the new layout paints. A plain module-level variable, not
// sessionStorage/a bus - both components run in the same JS realm on the
// real page (never inside the preview iframe, which has no is_authorized
// switch of its own), so there's no cross-document handoff to support.
let pendingScrollY = null;

export const setPendingAuthSwitchScroll = (y) => {
    pendingScrollY = y;
};

export const takePendingAuthSwitchScroll = () => {
    const value = pendingScrollY;
    pendingScrollY = null;
    return value;
};
